// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// RCCL
import { RclExcaliburModule } from '@rccl/rcl-excalibur';

// OLCI
import { CoreModule } from '../core/core.module';

import { HealthCenterContainerComponent } from './health-center-container/health-center.container';
import { HealthCenterPageComponent } from './health-center-page/health-center-page.component';

@NgModule({
	imports: [CoreModule, CommonModule, RclExcaliburModule],
	declarations: [HealthCenterContainerComponent, HealthCenterPageComponent],
})
export class HealthCenterModule {}
